import { render, staticRenderFns } from "./CreatePasswordPage.vue?vue&type=template&id=669b5eec&"
import script from "./CreatePasswordPage.vue?vue&type=script&lang=js&"
export * from "./CreatePasswordPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports